import { Gender } from '@/root/shared-providers/BookingCart/types'
import * as yup from 'yup'

/**
 * Creates a Yup schema for PriceCard form validation with dynamic max quantity constraints.
 * @param priceCodeAmounts - Record mapping price codes to their maximum allowed quantities
 */
export const createPriceCardSchema = (priceCodeAmounts: Record<string, number>) => {
  const quantitySchema = yup.object(
    Object.entries(priceCodeAmounts).reduce(
      (acc, [code, maxAmount]) => {
        acc[code] = yup
          .number()
          .transform((value, originalValue) => (originalValue === '' ? undefined : value))
          .min(0, 'Quantity must be at least 0')
          .max(maxAmount, `Quantity cannot exceed ${maxAmount}`)
          .optional()

        return acc
      },
      {} as Record<string, yup.AnySchema>
    )
  )

  const passengerSchema = yup.array().of(
    yup.object({
      firstName: yup.string().required('First name is required'),
      lastName: yup.string().required('Last name is required'),
      priceCategory: yup.string().required('PriceCategory is required'),
      gender: yup.mixed<Gender>().oneOf(['M', 'F']).optional().default(undefined),
      additionalInfo: yup.string().default(''),
      citizenship: yup.string().required('Citizenship is required'),
      birthdate: yup.string().required('Birthdate is required'),
      personalId: yup
        .string()
        .transform((value, originalValue) => (originalValue === '' ? undefined : value))
        .optional(),
      personalIdConfirmed: yup.boolean().default(false),
    })
  )

  return yup.object({
    quantities: quantitySchema.required(),
    passengers: passengerSchema.required().default([]),
  })
}
